import { CreateMediaInput } from '@/types/schema';

export interface AddQuestionMediaProps {
  media?: CreateMediaInput;
  onChange: (media?: CreateMediaInput) => void;
}

export enum AddQuestionMediaType {
  Image = 'IMAGE',
  Video = 'VIDEO',
}
